import React, { useEffect, useState } from 'react';
import { JsonFormsCore, createAjv } from '@jsonforms/core';

import { Form } from './forms/form';
import schema from './forms/schemas/extension/schema.json';
import uiSchema from './forms/schemas/extension/uischema.json';
import { STORAGE_KEY_AGENT_EXTENSION_FROM_API } from '../../constants';

const extensionMessage =
  'The assigned extension does not match with the current extension. Please review and Update, if needed.';

const handleAjv = createAjv();
const validateExtension: any = (extnschema: any, data: any) => {
  const localStorageAgentExtension = localStorage.getItem(
    STORAGE_KEY_AGENT_EXTENSION_FROM_API,
  );

  let isValid = true;
  const pattern = new RegExp('^([2,3,4,5,8])|^([2,3,4,5,8])([0-9]+)$');
  const patternOnlyNumber = new RegExp('^([0-9]{5})?$');
  let msg = '';
  if (!data) {
    isValid = false;
    msg = 'Extension is required';
  } else if (!pattern.test(data)) {
    isValid = false;
    msg = 'Extension can only start with 2, 3, 4, 5 or 8';
  } else if (!patternOnlyNumber.test(data)) {
    isValid = false;
    msg = 'Please enter a 5 digit extension';
  } else if (
    localStorageAgentExtension &&
    data !== localStorageAgentExtension
  ) {
    isValid = false;
    msg = extensionMessage;
  }
  validateExtension.errors = [
    {
      keyword: 'validateExtn',
      message: msg,
      params: { keyword: 'validateExtn' },
    },
  ];
  return isValid;
};
handleAjv.addKeyword({
  validate: validateExtension,
  errors: true,
  keyword: 'validateExtn',
});

export interface ExtensionControlProps {
  onChange?(state: Pick<JsonFormsCore, 'data' | 'errors'>): void;
  extensionData: any;
  validator: (valid: boolean, extn: string) => void;
  locationKey?: string;
}

export const ExtensionControl = ({
  onChange,
  extensionData,
  validator,
  locationKey,
}: ExtensionControlProps) => {
  const [props, setProps] = useState<any>({
    extension: extensionData.extension ? extensionData.extension : '',
  });
  const [currentLocationKey] = useState<string | undefined>(locationKey);

  useEffect(() => {
    if (
      locationKey !== currentLocationKey ||
      locationKey === 'extension-dialog'
    ) {
      setProps({
        extension: extensionData.extension,
      });
    }
  }, [locationKey, extensionData.extension, currentLocationKey]);

  // On change handler
  const _changeHandler = (state: Pick<JsonFormsCore, 'data' | 'errors'>) => {
    let valid = true;
    let stateMessage = null;

    if (
      (state && state.errors && state.errors.length) ||
      !state.data.extension
    ) {
      stateMessage = state.errors ? state.errors[0].message : '';

      valid = false;
    }
    if (state.data) {
      setProps(state.data);
    }

    if (onChange) {
      onChange(state);
    }

    if (validator) {
      validator(valid, state.data.extension);

      const localStorageAgentExtension = localStorage.getItem(
        STORAGE_KEY_AGENT_EXTENSION_FROM_API,
      );

      if (
        state.data.extension &&
        !valid &&
        state.data.extension !== localStorageAgentExtension &&
        stateMessage !== null &&
        stateMessage === extensionMessage
      ) {
        validator(true, state.data.extension);
      }
    }
  };

  return (
    <Form
      onChange={_changeHandler}
      data={props}
      uischema={uiSchema}
      schema={schema}
      ajv={handleAjv}
    />
  );
};
